module.exports = __webpack_public_path__ + "static/media/01-Rietberg@2x.2cc1cc69.jpg";